<template>
  <f-p-payment-layout
    :type="type"
    :guid="guid"
    :bluredProp="bluredProp"
    @actionType="actionType"
    @isLoading="isLoading"
    @clearInputErrorsPayments="clearInputErrorsPayments"
    @clearOthersPayments="clearOthersPayments"
    @checkAnyInput="checkAnyInput"
  >

    <template #paymentButtons >
      <div class="section-bottom">
        <hr class="horizontal-line">
        <!-- CANCEL -->
        <f-p-cancel-button :breadcrumbTo="'Recurring'" :cancelTitle="$lang.messages.cancel"></f-p-cancel-button>
        <!-- SUBMIT -->
        <button type="submit" class="action-btn">
          <span v-if="whatActionType === 'add'" v-show="!whatIsLoading">{{ $lang.messages.scheduleExpense }}</span>
          <span v-if="whatActionType === 'edit'" v-show="!whatIsLoading">{{ $lang.messages.save }}</span>
          <ClipLoader :loading="whatIsLoading" :color="'#fff'" :size="'20px'" />
        </button>
      </div>

      <div :class="$style.section__bottom">
        <hr class="horizontal-line">
      </div>
    </template>

  </f-p-payment-layout>
</template>

<script>
  import FPPaymentLayout from "./FPAddPaymentLayout";
  import ClipLoader from 'vue-spinner/src/ClipLoader';
  import FPCancelButton from "@/components/common/FPCancelButton";

  export default {
    name: "FPScheduleRecurringPayment",
    components: {
      'f-p-payment-layout': FPPaymentLayout,
      ClipLoader,
      'f-p-cancel-button': FPCancelButton
    },
    props: {
      type: {
        type: String,
        required: true,
        default: () => {
          return '';
        }
      },
      guid: {
        type: String,
        required: true,
        default: () => {
          return '';
        }
      },
      bluredProp: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        tooltipId: 0,
        whatActionType: '',
        whatIsLoading: false
      }
    },
    methods: {
      clearInputErrorsPayments (val) {
        this.$emit('clearInputErrorsPayments', val)
      },
      clearOthersPayments (val) {
        this.$emit('clearOthersPayments', val)
      },
      checkAnyInput () {
        this.$emit('checkAnyInput')
      },
      actionType (val) {
        this.whatActionType = val
      },
      isLoading (val) {
        this.whatIsLoading = val
      }
    }
  }
</script>

<style module>
  .section__bottom {
    width: 34%;
    float: right;
    margin-top: -73px;
    padding-right: 15px;
  }
</style>
